import support from "./support.js";

export default {
  memberLevelSave(data) {
    return support.post("Member/memberLevelSave", data);
  },
}
